import {Role} from "@/utils/utils";
import dtpBlurringVideosPage from "@/modules/dtp-blurring-videos-module/views/dtp-blurring-videos/dtp-blurring-videos-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/dtp-blurring-videos-module",
    component: Module,
    children: [
        {
            path: '/',
            name: 'dtp-blurring-videos-module',
            meta: {
                product: 'Realite Admin',
                title: 'DTP Blurring Videos',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission: 'data-packaging:get-dtp-blurring-report',
                topBarTitle: '',
                menuPriority: 12,
                hasMenu: true,
                hasInternalTransition: false,
                menuGroup: 'DTP',
                menuGroupPriority: 6
            },
            component: dtpBlurringVideosPage
        }
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
